// modified by Katarzyna Krasnowska for SCWAD demo

import COMBO from './components/demos/COMBO';
//import SCWADEntailmentRelatedness from './components/demos/SCWADEntailmentRelatedness';
import otherIcon from './icons/other-14px.svg';
import COMBOEnglish from "./components/demos/COMBOEnglish";

// This is the order in which they will appear in the menu
const modelGroups = [
    {
        label: "COMBO",
        iconSrc: otherIcon,
        defaultOpen: true,
        models: [
            {model: "combo-eng", name: "English", component: COMBOEnglish},
            {model: "combo-pl", name: "Polish", component: COMBO},
        ]
    }
];

// Create mapping from model to component
let modelComponents = {}
modelGroups.forEach((mg) => mg.models.forEach(({model, component}) => modelComponents[model] = component));

let modelRedirects = {}
modelGroups.forEach((mg) => mg.models.forEach(
  ({model, redirects}) => {
    if (redirects) {
      redirects.forEach((redirect) => modelRedirects[redirect] = model)
    }
  }
));

export { modelComponents, modelGroups, modelRedirects }
